import Colors from '../../../../shared/assets/style/default/color';
import Props from '../../../../shared/types/props/button';
import Screen from '../../../../shared/utils/screen';

function ForwardIcon({ height, width }: Props) {
  return (
    <svg
      clipRule={'evenodd'}
      fill={`${Colors['light']}`}
      fillRule={'evenodd'}
      height={`${height || 56 * Screen.widthRatio}`}
      width={`${width || 92 * Screen.widthRatio}`}
      xmlns={'http://www.w3.org/2000/svg'}
      viewBox={'0 0 92 56'}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M45.8888 0.968952C47.6663 -0.187888 50.0516 -0.406345 52.1511 0.847337L52.1537 0.848884L89.0423 22.927C90.9926 24.0936 91.8549 26.1432 91.8549 28C91.8549 29.8568 90.9926 31.9064 89.0423 33.073L52.1511 55.1527C50.0516 56.4064 47.6663 56.1879 45.8888 55.0311C44.1367 53.8907 43 51.8789 43 49.577L43 6.42301C43 4.12109 44.1367 2.1093 45.8888 0.968952ZM49.1253 6.02892C49.075 6.08138 49 6.19859 49 6.42301L49 49.577C49 49.8014 49.075 49.9186 49.1253 49.9711L85.8351 28L49.1253 6.02892Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.88883 0.968952C4.6663 -0.187887 7.05161 -0.406345 9.15108 0.847337L9.15367 0.848884L46.0423 22.927C47.9926 24.0936 48.8549 26.1432 48.8549 28C48.8549 29.8568 47.9926 31.9064 46.0423 33.073L9.15109 55.1527C7.05162 56.4064 4.66631 56.1879 2.88884 55.0311C1.13671 53.8907 6.06144e-06 51.8789 5.65896e-06 49.577L-1.88632e-06 6.42301C-2.2888e-06 4.1211 1.1367 2.10929 2.88883 0.968952ZM6.1253 6.02892C6.07503 6.08138 6 6.19859 6 6.42301L6.00001 49.577C6.00001 49.8014 6.07504 49.9186 6.12531 49.9711L42.8351 28L6.1253 6.02892Z'
        fill='white'
      />
    </svg>
  );
}

export default ForwardIcon;
